import styled from 'styled-components';

import { control } from '../../styles/mixins';

const Container = styled.div`
  display: flex;
  height: 100vh;

  @media (max-width: 720px) {
    flex-direction: column;
  }
`;

const LeftHalfContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--bg);

  @media (max-width: 720px) {
    width: 100%;
  }

  button {
    margin-top: 2rem;
    margin-bottom: 4rem;
  }
`;

const LoginImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  margin-top: auto;
`;

const Logo = styled.img`
  width: 21rem;
  margin-top: 10rem;
`;

const Headline = styled.p`
  font-size: 2.8rem;
  font-weight: 700;
  color: var(--ink);
  margin-top: 4rem;
  margin-bottom: 2rem;
`;

const ForgotPassword = styled.p`
  font-size: 1.35rem;
  font-weight: 600;
  color: var(--ink-soft);
  cursor: pointer;
  margin-bottom: 5rem;

  :hover {
    text-decoration: underline;
  }
`;

const LoginInput = styled.input`
  ${control}
  margin-top: 1rem;
`;

const RightHalfContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  /* A arte tem o topo chapado em #01ADEF e é ancorada no rodapé; o fundo
     precisa ser essa mesma cor, senão sobra uma faixa de outro azul acima
     dela. --accent é #009EE2 e era justamente o que aparecia. */
  background-color: var(--due-azul-500);
  overflow: hidden;

  @media (max-width: 720px) {
    width: 100%;
  }
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;

  :hover,
  :focus-within {
    svg {
      visibility: visible;
    }
  }

  input {
    width: 100%;
    padding-right: 4.8rem;
  }

  /* Ancorado na borda do campo, em vez das margens negativas que precisavam
     acompanhar o margin-top do input à mão. */
  svg {
    position: absolute;
    right: 1.6rem;
    top: calc(50% + 0.5rem);
    transform: translateY(-50%);
    visibility: ${({ showPassword }) => (showPassword ? 'visible' : 'hidden')};
    cursor: pointer;
    user-select: none;
    transition: opacity 0.2s;

    :hover {
      opacity: 0.8;
    }
  }
`;

const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 70%;
  max-width: 600px;

  /* O form é uma coluna flex, então sem isto o botão esticava para a largura
     inteira do campo. */
  > button {
    align-self: center;
  }
`;

export {
  Container,
  Logo,
  Headline,
  ForgotPassword,
  LoginInput,
  LeftHalfContainer,
  RightHalfContainer,
  LoginImage,
  InputContainer,
  LoginForm,
};
